var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.014 5.559H36.46v4.167a3.054 3.054 0 1 1-6.111 0V5.559H14.167v4.167a3.056 3.056 0 1 1-6.111 0V5.559H2.5A2.472 2.472 0 0 0 0 8.073v31.083a2.473 2.473 0 0 0 2.43 2.514h39.584a2.472 2.472 0 0 0 2.43-2.514V8.073a2.474 2.474 0 0 0-2.43-2.514zM11.111 33.337H8.334v-2.778h2.777v2.778zm0-6.945H8.334v-2.777h2.777v2.777zm0-6.944H8.334V16.67h2.777v2.778zm8.334 13.889h-2.778v-2.778h2.778v2.778zm0-6.945h-2.778v-2.777h2.778v2.777zm0-6.944h-2.778V16.67h2.778v2.778zm8.333 13.889H25v-2.778h2.778v2.778zm0-6.945H25v-2.777h2.778v2.777zm0-6.944H25V16.67h2.778v2.778zm8.334 13.889h-2.778v-2.778h2.777v2.778zm0-6.945h-2.778v-2.777h2.777v2.777zm0-6.944h-2.778V16.67h2.777v2.778z",
    fill: "#0E8073"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.111 11.114a1.389 1.389 0 0 0 1.39-1.388V1.392a1.39 1.39 0 0 0-2.778 0v8.334a1.389 1.389 0 0 0 1.388 1.388zM33.334 11.114a1.389 1.389 0 0 0 1.389-1.388V1.392a1.39 1.39 0 0 0-2.778 0v8.334a1.389 1.389 0 0 0 1.389 1.388z",
    fill: "#0E8073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.50d773209ce2e6d447b340bd6dd42da1.svg";
export { ForwardRef as ReactComponent };